__turbopack_context__.v({
  "aboutDesktop": "Queue-module-scss-module__meCFYa__aboutDesktop",
  "aboutDesktopSvg": "Queue-module-scss-module__meCFYa__aboutDesktopSvg",
  "aboutMobile": "Queue-module-scss-module__meCFYa__aboutMobile",
  "aboutMobileQueue": "Queue-module-scss-module__meCFYa__aboutMobileQueue",
  "aboutMobileQueueSvg": "Queue-module-scss-module__meCFYa__aboutMobileQueueSvg",
  "aboutMobileSvg": "Queue-module-scss-module__meCFYa__aboutMobileSvg",
  "general": "Queue-module-scss-module__meCFYa__general",
  "general__description": "Queue-module-scss-module__meCFYa__general__description",
  "general__title": "Queue-module-scss-module__meCFYa__general__title",
  "headerBlock": "Queue-module-scss-module__meCFYa__headerBlock",
  "queueBlock_Second": "Queue-module-scss-module__meCFYa__queueBlock_Second",
  "queueBlock_SecondBlock": "Queue-module-scss-module__meCFYa__queueBlock_SecondBlock",
  "queueBlock_content": "Queue-module-scss-module__meCFYa__queueBlock_content",
  "queueBlock_contentDescription": "Queue-module-scss-module__meCFYa__queueBlock_contentDescription",
  "queueBlock_contentTitle": "Queue-module-scss-module__meCFYa__queueBlock_contentTitle",
  "queueBlock_first": "Queue-module-scss-module__meCFYa__queueBlock_first",
  "queueBlock_firstCopy": "Queue-module-scss-module__meCFYa__queueBlock_firstCopy",
  "queueBlock_firstDates": "Queue-module-scss-module__meCFYa__queueBlock_firstDates",
  "queueBlock_firstQueueImage": "Queue-module-scss-module__meCFYa__queueBlock_firstQueueImage",
  "queueBlock_firstQueueRightImage": "Queue-module-scss-module__meCFYa__queueBlock_firstQueueRightImage",
  "queueBlock_firstQueueSmallImage": "Queue-module-scss-module__meCFYa__queueBlock_firstQueueSmallImage",
  "queueBlock_firstQueueVideo": "Queue-module-scss-module__meCFYa__queueBlock_firstQueueVideo",
  "queueBlock_firstText": "Queue-module-scss-module__meCFYa__queueBlock_firstText",
  "queueBlock_info": "Queue-module-scss-module__meCFYa__queueBlock_info",
  "queueBlock_leftBlock": "Queue-module-scss-module__meCFYa__queueBlock_leftBlock",
  "queueBlock_listDescription": "Queue-module-scss-module__meCFYa__queueBlock_listDescription",
  "queueBlock_media": "Queue-module-scss-module__meCFYa__queueBlock_media",
  "queueBlock_rightBlock": "Queue-module-scss-module__meCFYa__queueBlock_rightBlock",
  "queueBlock_rightBlockFooterdescription": "Queue-module-scss-module__meCFYa__queueBlock_rightBlockFooterdescription",
  "queueBlock_rightBlockFooterdescription_smallImageMob": "Queue-module-scss-module__meCFYa__queueBlock_rightBlockFooterdescription_smallImageMob",
  "queueBlock_secondQueueImage": "Queue-module-scss-module__meCFYa__queueBlock_secondQueueImage",
  "queueBlock_secondQueueRightImage": "Queue-module-scss-module__meCFYa__queueBlock_secondQueueRightImage",
  "queueBlock_video": "Queue-module-scss-module__meCFYa__queueBlock_video",
  "queueBlock_videoButton": "Queue-module-scss-module__meCFYa__queueBlock_videoButton",
  "titleBlock": "Queue-module-scss-module__meCFYa__titleBlock",
  "titleBlock_description": "Queue-module-scss-module__meCFYa__titleBlock_description",
  "titleBlock_title": "Queue-module-scss-module__meCFYa__titleBlock_title",
});
